/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import { IconProps } from "../types";
const StarFillIcon = ({
  size = 24,
  ...props
}: IconProps) => {
  return <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width={size} height={size} {...props}><path fillRule="evenodd" d="M10.788 3.308c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305L17.33 14.58l1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.452l-4.627 2.826c-.996.608-2.231-.29-1.96-1.425L6.67 14.58l-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434z" clipRule="evenodd" /></svg>;
};
export default StarFillIcon;